import { useInterval } from "./useInterval";

const useSlider = (slides, step, dispatchSetChapterSlideStep) => {
  const slide = slides[step];
  let delay = slide?.duration;
  const nextSlide = () => {
    if (step + 1 > slides.length) {
      delay = null;
    } else {
      dispatchSetChapterSlideStep(step + 1);
    }
  };

  const setSlide = (nextStep) => {
    dispatchSetChapterSlideStep(nextStep);
  };

  useInterval(
    () => {
      nextSlide();
    },
    delay
    // 3000
  );

  return { nextSlide, setSlide, slide };
};

export default useSlider;
